<template>
    <div>
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
        <ModalsContainer />
        <CookiesPopup />
    </div>
</template>
<script lang="ts">
import { ModalsContainer } from 'vue-final-modal'
import { storeToRefs } from 'pinia'
import { useStore } from '~/stores/store'
import { useAuthStore } from '~/stores/authStore'
import { AppEvents } from '~/types/events'
import CookiesPopup from '~/components/CookiesPopup.vue'

const description = ref('Easly | Najprostszy w użyciu sposób na prezentacje portfolio dla agencji IT, marketinowych i designerskich. Porównaj najlepszych dostawców B2B, zaproś ich do przetargu. Marketplace w którym obsłużysz cały proces wyboru dostawcy.')

export default {
    components: {
        CookiesPopup,
        ModalsContainer,
    },
    setup() {
        useHead({
            title: 'Easly.app',
            titleTemplate: 'Easly | %s',
            ogImage: '/favicon.ico',
            meta: [{
                name: 'description',
                 content: description
            }],
        })
        const { $event, $listen } = useNuxtApp()
        const authStore = useAuthStore()
        const { authenticated } = storeToRefs(authStore)
        const { checkUser } = useAuthStore()
        const { fetchCities } = useStore()
        const { cities } = storeToRefs(useStore())
        const route = useRoute()
        const { initialize } = useHotjar();
        function removeEaslyWidget() {
            const wiget = document.querySelector('.easly-widget')

            if (wiget && route.name.split('__')[0] !== 'about') {
                wiget.remove()
            }
        }
        watch(() => route.fullPath, () => {
            removeEaslyWidget()
        });

        onMounted(async () => {
            initialize()
            await refreshNuxtData()
            $event(AppEvents.FETCH_USER_DATA)
            const checkUserInterval = setInterval(async () => {
                if (!authenticated.value) {
                    clearInterval(checkUserInterval)
                    return
                }
                await checkUser()
            }, 60000 * 2)
            setTimeout(async () => {
                cities.value = (await fetchCities()) as any
            }, 0)

            removeEaslyWidget()
        })

        $listen(AppEvents.RESET_CHAT_DATA, () => {

            const chatStore = storeToRefs(useChatStore())

            chatStore.userId.value = null
            chatStore.chatList.value = []
            chatStore.messages.value = []
            chatStore.roomId.value = null
            chatStore.selectedChatData.value = null
            chatStore.aiChatData.value = null
            chatStore.currentView.value = 'list'
        })
    },
}
</script>
